(() => {
  const initializeBrowser = (root) => {
    if (root.dataset.discoveryReady) return;
    root.dataset.discoveryReady = 'true';
    const cards = [...root.querySelectorAll('[data-design-card]')];
    const filters = [...root.querySelectorAll('[data-design-filter]')];
    const count = root.querySelector('[data-discovery-count]');
    let activeFilter = 'all';

    const update = () => {
      const matching = cards.filter(card => activeFilter === 'all' || card.dataset.designMood === activeFilter);
      cards.forEach(card => { card.hidden = !matching.includes(card); });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.designFilter === activeFilter)));
      count.textContent = `${matching.length} of ${cards.length} designs`;
    };

    filters.forEach(button => {
      const value = button.dataset.designFilter;
      if (value !== 'all' && !cards.some(card => card.dataset.designMood === value)) button.hidden = true;
      button.addEventListener('click', () => {
        activeFilter = value;
        update();
      });
    });
    root.querySelectorAll('[data-discovery-controls]').forEach(control => { control.hidden = false; });
    update();
  };

  const initialize = (scope = document) => {
    if (scope.matches?.('[data-ten-love-discovery]')) initializeBrowser(scope);
    scope.querySelectorAll('[data-ten-love-discovery]').forEach(initializeBrowser);
    // Shopify section IDs include a dynamic template prefix; resolve actual review anchors.
    document.querySelectorAll('[data-ten-love-review-jump]').forEach(link => {
      const reviews = document.querySelector('[data-ten-love-reviews]');
      if (reviews) link.href = `#${reviews.id}`;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
